import { render, staticRenderFns } from "./SellerForm.vue?vue&type=template&id=66d3a056&scoped=true&"
import script from "./SellerForm.vue?vue&type=script&lang=js&"
export * from "./SellerForm.vue?vue&type=script&lang=js&"
import style0 from "./SellerForm.vue?vue&type=style&index=0&id=66d3a056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d3a056",
  null
  
)

export default component.exports